
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tokens",
      function () {
        return require("private-next-pages/tokens/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tokens"])
      });
    }
  